/**
 * 统一请求拦截器
 * 功能：
 * 1. 自动携带 token
 * 2. 统一处理 session 过期
 * 3. 统一错误提示
 */
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import router from '@/router'

const request = axios.create({
  baseURL: '/apiserve/crmapi/',
  timeout: 30000,
  withCredentials: true, // 允许跨域携带 cookie/session
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// 请求拦截器：自动带 token
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.data = config.data || ''
      // 如果是字符串（已序列化），追加 token
      if (typeof config.data === 'string') {
        config.data += config.data ? '&' : ''
        config.data += `token=${encodeURIComponent(token)}`
      } else if (typeof config.data === 'object') {
        config.data.token = token
      }
    }
    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器：统一处理 session 过期
request.interceptors.response.use(
  response => {
    const data = response.data
    
    // 检查是否是 session 过期错误
    if (data && (data.error === 'session_expired' || data.error === 'Invalid token')) {
      localStorage.clear()
      ElMessage.error('登录已过期，请重新登录')
      router.replace('/login')
      return Promise.reject(new Error('Session expired'))
    }
    
    // 其他业务错误，正常返回让页面处理
    return data
  },
  error => {
    console.error('Response error:', error)
    
    if (error.response) {
      switch (error.response.status) {
        case 401:
          localStorage.clear()
          ElMessage.error('未授权，请重新登录')
          router.replace('/login')
          break
        case 403:
          ElMessage.error('没有权限访问')
          break
        case 404:
          ElMessage.error('请求的资源不存在')
          break
        case 500:
          ElMessage.error('服务器错误，请稍后重试')
          break
        default:
          ElMessage.error(error.message || '网络错误')
      }
    } else if (error.message.includes('timeout')) {
      ElMessage.error('请求超时，请检查网络')
    } else {
      ElMessage.error('网络连接失败')
    }
    
    return Promise.reject(error)
  }
)

export default request
